import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import './index.scss';

interface KontaktState extends BasePageState {}
interface KontaktModel {}

export default class KontaktPage extends Basepage<KontaktState, KontaktModel> {
  renderChild(): JSX.Element {
    return (
      <div id="kontakt">
        Kontakt
        <br />
        <form
          name="contact_us"
          action="https://www.moluna.de/index.php?main_page=contact_us&amp;action=send"
          method="post"
        >
          <input
            type="hidden"
            name="securityToken"
            value="cfbbddfd69a385bcc47fb87f2e59aa8c"
          />
          <address>
            <b>BUCHBUTLER</b>
            <br />
            <span style={{ color: '#C0C0C0' }}>
              ist eine Marke der <br />
              Moluna GmbH
            </span>
            <br />
            Engberdingdamm 27
            <br />
            48268 Greven
            <br />
            <br />
            Telefon: <a href="tel:+4925718072880">☎ 02571 / 8 07 28 80</a>
            <br />
            Telefax: 02571 / 5 69 89 30
            <br />
            E-Mail:
            <a href="mailto:service@buchbutler.de">service@buchbutler.de</a>
          </address>
          <div id="contactUsNoticeContent" className="content">
            <p>
              <strong>
                Bei Fragen oder Anregungen melden Sie sich gerne bei uns.
              </strong>
            </p>

            <p>Wir werden Ihnen schnellstmöglich antworten und helfen!</p>

            <p>
              Sie erreichen uns montag-freitags zwischen 10:00 und 16:00 Uhr.
            </p>

            <p>
              Bitte nennen Sie uns bei der Kontaktaufnahme immer Ihre
              Auftragsnummer, damit wir Ihr Anliegen sofort bearbeiten können.
            </p>

            <p>
              Ganz wichtig vorab: Hier <strong>arbeiten </strong>noch echte{' '}
              <strong>Menschen</strong>, und Menschen machen auch den einen oder
              anderen Fehler. Darum bitten wir Sie schon vorab um Nachsicht und
              Rücksichtnahme, wenn einmal etwas nicht so läuft, wie es laufen
              sollte und wir Sie enttäuscht haben.
            </p>

            <p>
              Wir versprechen Ihnen, es ist niemals unsere Absicht Sie zu
              verärgern oder zu enttäuschen und bemühen uns immer eine, für Sie
              zufriedenstellende, Lösung zu finden.
            </p>

            <p>Mit freundlichen Grüßen aus Greven an der Ems&nbsp;</p>

            <p>Ihr Buchbutler.de Service-Team aus Greven an der Ems</p>
          </div>

          {/*<fieldset id="contactUsForm">
            <legend>Schreiben Sie uns</legend>
            <div className="alert forward">* = Pflichtfeld</div>
            <br className="clearBoth" />

            <label className="inputLabel" htmlFor="contactname">
              Ihr Name:
            </label>
            <input type="text" name="contactname" size={40} id="contactname" />
            <span className="alert">*</span>
            <br className="clearBoth" />

            <label className="inputLabel" htmlFor="email-address">
              Ihre E-Mail Adresse:
            </label>
            <input type="text" name="email" size={40} id="email-address" />
            <span className="alert">*</span>
            <br className="clearBoth" />

            <label htmlFor="enquiry">
              Ihre Nachricht:<span className="alert">*</span>
            </label>
            <textarea name="enquiry" cols={30} rows={7} id="enquiry"></textarea>
            <input
              type="text"
              name="should_be_empty"
              size={40}
              id="CUAS"
              style={{ visibility: 'hidden', display: 'none' }}
              autoComplete="off"
    />
            <script
              src="https://www.google.com/recaptcha/api.js"
              async
              defer
    ></script>
            <div
              className="g-recaptcha"
              data-sitekey="6LdidCAaAAAAALAwn7ks9fJ4uwgKvyZR2_Sqp4Qb"
            >
              <div style={{ width: 304, height: 78 }}>
                <div>
                  {/*<iframe
                    title="reCAPTCHA"
                    src="https://www.google.com/recaptcha/api2/anchor?ar=1&amp;k=6LdidCAaAAAAALAwn7ks9fJ4uwgKvyZR2_Sqp4Qb&amp;co=aHR0cHM6Ly93d3cubW9sdW5hLmRlOjQ0Mw..&amp;hl=de&amp;v=ovmhLiigaw4D9ujHYlHcKKhP&amp;size=normal&amp;cb=kdqb7o1dfsed"
                    role="presentation"
                    name="a-vhettn1oesko"
                    scrolling="no"
                    sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox allow-storage-access-by-user-activation"
                    width="304"
                    height="78"
                    frameborder="0"
  ></iframe>
                </div>
                <textarea
                  id="g-recaptcha-response"
                  name="g-recaptcha-response"
                  className="g-recaptcha-response"
                  style={{
                    width: '250px',
                    height: '40px',
                    border: '1px solid rgb(193, 193, 193)',
                    margin: '10px 25px',
                    padding: '0px',
                    resize: 'none',
                    display: 'none',
                  }}
                ></textarea>
              </div>
              <iframe style={{ display: 'none' }}></iframe>
            </div>
            <br />
          </fieldset>
          <div className="buttonRow forward">
            <input
              className="cssButton submit_button button  button_send"
              onMouseOver={this.className='cssButtonHover  button_send button_sendHover'} onmouseout="this.className='cssButton submit_button button  button_send'" type="submit"
              value="Absenden"
            />
          </div>
          <div className="buttonRow back">
            <a href="https://www.moluna.de/index.php?main_page=start&amp;frame=api">
              <span
                className="cssButton normal_button button  button_back" /*onmouseover="this.className='cssButtonHover normal_button button  button_back button_backHover'" onmouseout="this.className='cssButton normal_button button  button_back'"
              >
                &nbsp;Zurück&nbsp;
              </span>
            </a>
          </div>
          */}
        </form>
      </div>
    );
  }
  initState(base: BasePageState): KontaktState {
    let newState: KontaktState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Kontakt';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Kontakt</span>;
  }
  getType(): string {
    return 'KontaktPage';
  }
}
